import React from "react";

import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import styles from "./Header.module.css";

interface SwitcherProps {
  handler: () => void;
  checked: boolean;
}

function Switcher({ handler, checked }: SwitcherProps) {
  return (
    <div className={styles.themeToggle}>
      <span className={styles.toggleIcon}>&#x263C;</span>
      <ToggleSwitch handler={handler} checked={checked} />
    </div>
  );
}

interface HeaderProps {
  orgId: string | undefined;
  toggleTheme: () => void;
  curTheme: string;
}

export const Header: React.FC<HeaderProps> = ({ toggleTheme, curTheme }) => {
  return (
    <div className={styles.header}>
      <h1 className={styles.title}>Resource Overview</h1>
      <div className={styles.right}>
        <Switcher handler={toggleTheme} checked={curTheme === "Dark"} />
      </div>
    </div>
  );
};

export default Header;
